import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "42",
  height: "38",
  fill: "none",
  viewBox: "0 0 38 38"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3.808 6.919c3.548-4.95 15.163-10.924 25.007-3.24.263.183.48.365.656.538a18 18 0 0 0-1.85-1.227C19.153-1.898 8.327 1.002 3.44 9.469c-4.888 8.466-1.987 19.292 6.479 24.18s19.292 1.987 24.18-6.479c3.904-6.762 2.84-15.028-2.06-20.573a7 7 0 0 1 1.308.987c5.663 6.973 5.902 16.243-.502 23.344-6.733 7.467-17.753 9.315-26.312 1.905-7.65-6.624-8.612-17.701-2.725-25.914" }, null, -1)
  ])))
}
export default { render: render }